import { render, staticRenderFns } from "./BaseStatusPill.vue?vue&type=template&id=69cc23e4"
import script from "./BaseStatusPill.vue?vue&type=script&lang=js"
export * from "./BaseStatusPill.vue?vue&type=script&lang=js"
import style0 from "./BaseStatusPill.vue?vue&type=style&index=0&id=69cc23e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports